if($('header#header').length){
    $('.search input[type="search"]').attr('placeholder', 'Hledaný výraz, produkt, artiklové číslo, kategorie, EAN/GTIN, značka...')
    $('.header-top').append($('.top-navigation-bar .responsive-tools'))
    $('nav#navigation .menu-image img').each(function(){
        $(this).attr('data-src', $(this).attr('data-src').replace('thumb', 'orig'))
        $(this).attr('src', $(this).attr('data-src'))
    })
    $(document).ready(function(){
        $('#formSearchForm div.search-whisperer').after('<span class="searchClose"></span>')
    })
    $(document).on('click', '.searchClose', function(){
        $('body').removeClass('search-focused')
        $('.search-whisperer').removeClass('active').html('')
        $('input[type="search"]').val('')
        $('body').removeClass('user-action-visible, search-window-visible')
    })
    
}